import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import PostCard from '../components/PostCard';
import api from '../api';

export default function PostDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/posts/${id}`)
      .then(res => setPost(res.data.post))
      .catch(() => setError('Post not found'))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div style={{ minHeight: '100vh', paddingBottom: 120, background: '#0e0a08' }}>
      <Navbar />

      <div style={{ borderBottom: '1px solid rgba(237,228,211,0.08)', background: 'rgba(18,12,9,0.3)' }}>
        <div style={{ maxWidth: 680, margin: '0 auto', padding: '16px 22px' }}>
          <Link to="/" style={{ color: 'rgba(237, 228, 211, 0.38)', fontSize: 14, textDecoration: 'none', fontFamily: '"Geist", "Inter", system-ui, sans-serif' }}>
            &larr; Back to The Stage
          </Link>
        </div>
      </div>

      <main style={{ maxWidth: 680, margin: '0 auto', padding: '24px 22px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '64px 0' }}>
            <p style={{ color: '#e8b547', fontFamily: '"Instrument Serif", serif', fontSize: 18 }}>Loading...</p>
          </div>
        ) : error ? (
          <div style={{ textAlign: 'center', padding: '64px 0' }}>
            <div style={{ background: '#120c09', border: '1px solid rgba(237,228,211,0.08)', borderRadius: 16, padding: 40, maxWidth: 380, margin: '0 auto' }}>
              <p style={{ color: 'rgba(237, 228, 211, 0.38)', fontFamily: '"Geist", "Inter", system-ui, sans-serif' }}>{error}</p>
            </div>
          </div>
        ) : (
          <PostCard post={post} showFullReplies />
        )}
      </main>
    </div>
  );
}
